<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog
        v-model="isShow"
        persistent
        max-width="600"
        @keydown.esc="onClickNo()">
        <v-card class="pa-1" color="green lighten-4">
            <!-- <v-app-bar dense color="primary" dark elevation="0">
                <v-list-item-title>
                    {{params.title}}
                </v-list-item-title>
            </v-app-bar> -->
            <Title :title="params.title" dense />
            <v-card-text class="subtitle-1 font-weight-medium black--text pa-3">
                <!-- <v-img v-if="params.icon != ''" src="@/assets/icons/icon_warning.png" width="64"/>
                <div v-html="params.message" /> -->

                <div class="d-flex flex-no-wrap">
                    <v-avatar class="ma-3" rounded v-if="params.icon != ''">
                        <v-img v-if="params.icon != ''" src="@/assets/icons/icon_warning.png" width="64"/>
                    </v-avatar>                    
                    <div v-html="params.message" class="font-weight-bold" :style="$vuetify.breakpoint.xs ? 'font-size:small' : 'font-size:medium'" />
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pt-2">
                <v-spacer></v-spacer>
                <v-btn v-if="params.buttonYes != ''" @click.native="onClickYes()" color="primary">{{params.buttonYes}}</v-btn>
                <v-btn v-if="params.buttonNo != ''" @click.native="onClickNo()" color="primary">{{params.buttonNo}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Title from '@/components/seedling/items/TitleBar'
    export default {
        components: {
            Title,
        },
        data: function (){
            return {
                isShow: false,
                params: {
                    title: "確認",
                    message: "宜しいですか？",
                    buttonYes: "はい",
                    buttonNo: "いいえ",
                    width: "auto",
                    icon: "",
                    listenerYes: null,
                    listenerNo: null
                }
            }
        },
        methods: {
            onClickYes: function () {
                if (this.params.listenerYes != null) {
                    if (this.params.listenerYes() == true) {
                        this.isShow = false
                    }
                } else {
                    this.isShow = false
                }
            },
            onClickNo: function () {
                if (this.params.listenerNo != null) {
                    if (this.params.listenerNo() == true) {
                        this.isShow = false
                    }
                } else {
                    this.isShow = false
                }
            },
            show: function (params) {
                if (params != null) {
                    if (params.title != undefined) this.params.title = params.title
                    if (params.message != undefined) this.params.message = params.message
                    if (params.buttonYes != undefined) this.params.buttonYes = params.buttonYes
                    if (params.buttonNo != undefined) this.params.buttonNo = params.buttonNo
                    if (params.width != undefined) this.params.width = params.width
                    if (params.icon != undefined) this.params.icon = params.icon
                    if (params.listenerYes != undefined) this.params.listenerYes = params.listenerYes
                    if (params.listenerNo != undefined) this.params.listenerNo = params.listenerNo                    
                }
                this.isShow = true
            }
        }
    }
</script>
